module.exports = __webpack_public_path__ + "img/add_icon.7ea18670.svg";